module.exports = __webpack_public_path__ + "static/media/three.9f234384.png";